// extracted by mini-css-extract-plugin
module.exports = {"modal_animation_duration":"200ms","icon":"onfido-sdk-ui-crossDevice-ClientSuccess-icon","text":"onfido-sdk-ui-crossDevice-ClientSuccess-text"};